import { createAction, createStandardAction } from 'typesafe-actions';

import { Location } from 'history';
import { Config } from '../../../common/types/config';
import { AppLookupValuesDTO } from '../../types/dto/AppLookupValuesDTO';
import { GeolocationsDTO } from '../../types/dto/GeolocationsDTO';
import { PMPoliciesDTO } from '../../types/dto/PMPoliciesDTO';
import { PolicyConsentDTO } from '../../types/dto/PolicyConsentDTO';
import { PolicyDTO } from '../../types/dto/PolicyDTO';

export const pingRequest = createAction('@@app/PING_REQUEST');
export const pingSuccess = createAction('@@app/PING_SUCCESS');
export const pingFailure = createAction('@@app/PING_FAILURE');

export const logClientInfoRequest = createAction('@@app/LOG_CLIENTINFO_REQUEST');
export const logClientInfoSuccess = createAction('@@app/LOG_CLIENTINFO_SUCCESS');
export const logClientInfoFailure = createAction('@@app/LOG_CLIENTINFO_FAILURE');

export const selectPolicyConsent = createStandardAction('@@app/SELECT_POLICY_CONSENT')<PolicyConsentDTO>();
export const setPolicyConsentsRequest = createAction('@@app/SET_POLICY_CONSENTS_REQUEST');
export const setPolicyConsentsSuccess = createAction('@@app/SET_POLICY_CONSENTS_SUCCESS');
export const setPolicyConsentsFailure = createAction('@@app/SET_POLICY_CONSENTS_FAILURE');

export const loadLookupValuesRequest = createAction('@@app/LOADLOOKUPS_REQUEST');
export const loadLookupValuesSuccess = createStandardAction('@@app/LOADLOOKUPS_SUCCESS')<AppLookupValuesDTO>();
export const loadLookupValuesFailure = createAction('@@app/LOADLOOKUPS_FAILURE');

export const getGeolocationsRequest = createAction('@@app/GET_GEOLOCATION_REQUEST');
export const getGeolocationsSuccess = createStandardAction('@@app/GET_GEOLOCATION_SUCCESS')<GeolocationsDTO[]>();
export const getGeolocationsFailure = createAction('@@app/GET_GEOLOCATION_FAILURE');

export const updateConfig = createStandardAction('@@app/UPDATE_CONFIG')<Config>();

export const menuGoBackUrl = createStandardAction('@@app/MENU_GO_BACK_URL')<Location<any>>();

export const loadPoliciesRequest = createAction('@@app/LOADPOLICIES_REQUEST');
export const loadPoliciesSuccess = createStandardAction('@@app/LOADPOLICIES_SUCCESS')<PolicyDTO>();
export const loadPoliciesFailure = createAction('@@app/LOADPOLICIES_FAILURE');

export const loadPMPoliciesRequest = createAction('@@app/LOADPMPOLICIES_REQUEST');
export const loadPMPoliciesSuccess = createStandardAction('@@app/LOADPMPOLICIES_SUCCESS')<PMPoliciesDTO>();
export const loadPMPoliciesFailure = createAction('@@app/LOADPMPOLICIES_FAILURE');
